module.exports = __webpack_public_path__ + "img/ios-alarm.e66a15bb.svg";